module.exports = "https://bin.bnbstatic.com/_next/static/images/api-1771a7541e01aeeff1695e05b3ced273.png";